<template>
  <v-container class="pa-0">
    <div class="d-flex">
      <div class="flex-grow-1 pr-2" style="max-width: calc(50% - 0.5px)">
        <v-container v-if="pagamentoGuia.loading" class="text-center">
          <v-progress-circular color="primary" indeterminate />
        </v-container>
        <conciliacao-resumo-pagamento-guia-card v-else-if="pagamentoGuia.result" :pagamentoGuia="pagamentoGuia.result" />
      </div>

      <v-divider vertical />

      <div class="flex-grow-1 pl-2" style="max-width: calc(50% - 0.5px)">
        <conciliacao-resumo-faturamento-guia-card />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import ConciliacaoResumoFaturamentoGuiaCard from './ConciliacaoResumoFaturamentoGuiaCard.vue'
import ConciliacaoResumoPagamentoGuiaCard from './ConciliacaoResumoPagamentoGuiaCard.vue'

export default {
  components: {
    ConciliacaoResumoFaturamentoGuiaCard,
    ConciliacaoResumoPagamentoGuiaCard
  },
  computed: {
    ...mapState('conciliacao', ['pagamentoGuia'])
  }
}
</script>
